export enum RecipientsProviderOutputType {
    Include = 'include',
    Exclude = 'exclude',
}
